// removed by extract-text-webpack-plugin
module.exports = {"ButtonIcon":"ButtonIcon__ButtonIcon___22jFc","ButtonSquareWhite":"ButtonIcon__ButtonSquareWhite___1d3-4","ButtonWhiteColor":"ButtonIcon__ButtonWhiteColor___37-Xz"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/ButtonIcon/ButtonIcon.less
// module id = 1327
// module chunks = 0 1